/**
 * client/wrapper type for the Tab widget on parent/page
 */

import TabAnimator from '../core/animators/TabAnimator';
import BaseWidgetClient from '../core/BaseWidgetClient';
import TabPositioner from '../core/positioners/TabPositioner';
import WidgetTypes from '../core/enums/WidgetTypes';
import createNS from '../core/createNs';

export default function RegisterTab() {
    const Tab = class extends BaseWidgetClient {
        constructor(options) {
            if (!options.chatTab) {
                return;
            }
            super(
                Object.assign(options, {
                    widget: WidgetTypes.Tab // containerBg: 'blue'
                })
            );
            this.animator = new TabAnimator(options, this.DOM)
            this.positioner = new TabPositioner(this.options);
            this.ready();
        }

        ready() {
            super.ready();
            const me = this;
            me.create();
        }

        create() {
            super.create();
            const self = this;
            self.$container.innerHTML = `<iframe  tabindex="0"  class="page ${self.widget}_frame ${self.widget}_iframe_custom"   id="${self.iframeId}"  style="border: none;overflow-x:hidden; overflow-y:hidden;" marginheight="0" marginwidth="0" frameBorder="0" scrolling="no" horizontalscrolling="no" verticalscrolling="no"  allowtransparency="true" title="Chat Tab"></iframe>`;
            document.body.appendChild(self.$container);
            document.getElementById(self.parentDivId).style.position = 'fixed';
            document.getElementById(self.parentDivId).style.top = '50%';
            self.options.chatTab.chatTabLeftSide
                ? document.getElementById(self.parentDivId).style.left
                : (document.getElementById(self.parentDivId).style.right = 0);
            this.positioner.position({
                element: self.parentDivId,
                widgetType: WidgetTypes.Tab,
                isIframeOuterObject: true
            });
            this.animator.animate({
                element: self.parentDivId,
                widgetType: WidgetTypes.Tab
            });
            this.show();
        }

        show() {
            super.show();
        }
    };
    const fqName = `${WidgetTypes.Tab}_client`;
    // Export to window
    createNS(fqName, Tab);
}
